import { z } from 'zod';

export const postObjectQuery = /* graphql */ `
  postObject {
    node {
      id
      slug

      ... on Page {
        title
        uri
      }

      ... on Post {
        title
        categories {
          edges {
            node {
              id
              slug
            }
          }
        }
      }

      ... on Property {
        title
        propertyTypes {
          edges {
            node {
              id
              slug
            }
          }
        }
      }
    }
  }
`;

export const postObjectSchema = z.object({
  postObject: z.object({
    node: z
      .discriminatedUnion('__typename', [
        z.object({
          __typename: z.literal('Page'),
          uri: z.string(),
        }),

        z.object({
          __typename: z.literal('Post'),
          categories: z.object({
            edges: z.array(
              z.object({
                node: z.object({
                  id: z.string(),
                  slug: z.string(),
                }),
              })
            ),
          }),
        }),

        z.object({
          __typename: z.literal('Property'),
          propertyTypes: z.object({
            edges: z.array(
              z.object({
                node: z.object({
                  id: z.string(),
                  slug: z.string(),
                }),
              })
            ),
          }),
        }),
      ])
      .and(
        z.object({
          id: z.string(),
          slug: z.string(),
          title: z.string(),
        })
      ),
  }),
});
